var map = {
	"./Bavitha.jpg": 48835,
	"./Mani_Shankar.png": 51978,
	"./Murali.jpeg": 13621,
	"./Nikitha.jpeg": 86143,
	"./Shashi.jpg": 52296,
	"./Shradha.jpg": 26129,
	"./Shreshta.jpeg": 77983,
	"./Siri_Chandana.jpg": 58978,
	"./Swapanthi.jpeg": 47880,
	"./Ved.jpeg": 93204,
	"./Vedasi.jpg": 56830,
	"./amritha.jpeg": 21309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55790;